import type { FaireProductEntity } from "../../entity_types/product";

export const p_712k9kkvs1: FaireProductEntity = {
  token: "p_712k9kkvs1",
  type: "product",
  name: "California Poppies Tank Top - Made in USA",
  brandToken: "b_c251hgcw2g",
  brandName: "Habilis Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/24f9d2b689b7b53ac3a85d7d1391d62f1cef5b6b89476195cbe0f3d105d27d4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a9734b41c36a855dc41545d9a137f1d018d6daae2befe88114c7b4f7322ea73.jpeg",
    "https://cdn.faire.com/fastly/a7da634cbb86f36a7745dca995acf6ebb4d01945a0b10231d001a2b946fb15f1.jpeg",
    "https://cdn.faire.com/fastly/93bda88a54872f390f3650eb211a3efea961ce738f758ca210b233d4ad2c0d42.jpeg",
    "https://cdn.faire.com/fastly/1ff9d3ae8ea416e0d6f7e4bee78943f377589fd325a8b8b1b96beba220281afc.jpeg",
  ],
  priceDollars: 26.33,
  description:
    "California Poppies Women's Muscle Tank Top.\n\n• 50/38/12 Poly/Cotton/Rayon.\n• 100% Made in USA.\n\n\nNational Parks | Hiking | Backpacking | Travel | Fashion | Contemporary | California | Sustainable | Eco-Friendly | Small Batch",
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:45.019Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
